import BaseCartItemAmount from '~/themes/base/components/cart/CartItemAmount/CartItemAmount.js'

function normalizeAmount(value, decimalPosition) {
  const amount = Number(value || 0)

  return Number(amount.toFixed(decimalPosition))
}

export default {
  extends: BaseCartItemAmount,
  methods: {
    async updateBackend(value) {
      if (value === 0) {
        this.$refs.modal.show()
        return
      }

      const previousValue = normalizeAmount(this.item.amount, this.decimalPosition)

      this.loading = true

      try {
        const response = await this.$store.dispatch('cart/UPDATE_ITEM', {
          id: this.item.id,
          quantity: value,
        })

        if (!response) {
          this.$refs.numberInput.value = previousValue
          return
        }

        const cartItem = (this.$store.state.cart.cartData.items || []).find(item => item.id === this.item.id)
        this.$refs.numberInput.value = cartItem ? normalizeAmount(cartItem.amount, this.decimalPosition) : previousValue
      } finally {
        this.loading = false
      }
    },
    async removeItem() {
      this.loading = true

      try {
        const response = await this.$store.dispatch('cart/REMOVE_FROM_CART', this.item)

        if (!response) {
          this.$refs.numberInput.value = normalizeAmount(this.item.amount, this.decimalPosition)
        }
      } finally {
        this.loading = false
      }
    },
  },
}
